import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import dp from "../../Images/dp.svg";
import lc from "../../Images/lc.svg";
import pref from "../../Images/pref.svg";
import help from "../../Images/help.svg";
import rate from "../../Images/rate.svg";
import diary from "../../Images/diary.svg";
import viewall from "../../Images/viewall.png";
import school from "../../Images/school.png";
import profile from "../../Images/profile.png";
import password from "../../Images/password.png";
import assignments from "../../Images/assignments.svg";
import r_arrow from "../../Images/r_arrow.svg";
import SchoolCardV2 from "../../Components/Profile/SchoolCardV2";
import ProfileCardV2 from "../../Components/Profile/ProfileCard";
import HeaderV2 from "../../Layout/Header";
import { logout } from "../../../../services/users";
import ProfileSession from "../../Components/Profile/ProfileSession";
import BodyCard from "../../Components/Home/BodyCard";
import HomeProfileCardV2 from "../../Components/Home/ProfileCardV2/index";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

const ProfileV2 = () => {
  return (
    <>
      <div className="mb-1">
        <HeaderV2 to="/profile" title="Profile" />
        <div
          className="pt-1"
          style={{
            background:
              "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
            paddingBottom: "60px",
          }}
        >
          <ProfileCardV2 />

          <ProfileSession />
        </div>
        <div className="th-br-25 th-bg-white" style={{ marginTop: "-30px" }}>
          <div className="row px-3 pt-4 mx-0 my-auto">
            <div className="col-4">
              <BodyCard
                route="/aboutSchool"
                image={school}
                label="School Profile"
              />
            </div>
            <div className="col-4">
              <BodyCard
                route="/profileDetails"
                image={profile}
                label="My Profile"
              />
            </div>
            <div className="col-4">
              <BodyCard
                route="/password"
                image={password}
                label="Change Password"
              />
            </div>
          </div>

          <div className="mb-5 pb-4 text-center fixed-bottom">
            <button
              className="py-2 px-3 th-14 th-btn-primary"
              onClick={logout}
              style={{
                background:
                  "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
              }}
            >
              Logout
            </button>
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps)(ProfileV2);
